import { Row, Tabs } from "antd";
import React, { useEffect, useRef, useState } from "react";
import { withRouter } from "react-router-dom";
import { getProcesoRatificacion, getProcesoOrganizacion, getPaginaAcreditaciones} from "../../../api/notifica";
import Organizaciones from "../../../components/Admin/Notifications/Organizaciones";
import Ratifica from "../../../components/Admin/Notifications/Ratifica";
import useAuth from "../../../hooks/useAuth";
import { rol_captura_notifica, rol_consulta_notifica } from "../../../utils/Notifications/rolesNotifica";
import "../../../components/Admin/Notifications/Notifica.scss";
import Acreditaciones from "../../../components/Admin/Notifications/Acreditaciones";

function Notifications(props) {
    const { proceso, setLoader } = props;
    const {
        user: { rolUsuario }, //Se obtiene el rol del usuario
    } = useAuth();
    const isMounted = useRef(true); //Referencia que permite verificar si el componente esta visible
    const [rolModulo, setRolModulo] = useState({}); //Hook para almacenar los permisos
    const [ratificacion, setRatificacion] = useState();
    const [organizacion, setOrganizacion] = useState([]);
    const [acreditacion, setAcreditacion] = useState([]);
    const [refresh, setRefresh] = useState(false);
    let idProceso;
    //Se verica que este seleccionado un proceso electoral
    if(proceso.proceso) {
        idProceso = proceso.proceso.idProcesoElectoral;
    }
    //useEffect que valida que el componente este seleccionado de lo contrario cancela cualquier subcripción
    useEffect(() => {
        return () => {
            isMounted.current = false;
        };
    }, []);
    //useEffect que valida el rol del usuario
    useEffect(() => {
        //Valida los permisos que tienen el usuario
        let captura = false;
        let consulta = false;
        //Devuelve un true si cuenta con los permisos
        captura = rol_captura_notifica.includes(rolUsuario);
        consulta = rol_consulta_notifica.includes(rolUsuario);
        isMounted.current && setRolModulo(() => ({ captura, consulta })); //Se almacenan en el hook
    }, [rolUsuario]);

    useEffect(() => {

        getProcesoRatificacion().then((res) => {

            if(res.data.code === 200) {

                //console.log("getProcesoRatificacion data-->",res.data);

                setRatificacion(res.data);

            } else {
                //console.log("Entro en el else getProcesoRatificacion");

                setRatificacion(null);
            }

        }).catch((error) => {
            console.log(error);
            setRatificacion(null);
        });

    }, [refresh]);

    useEffect(() => {

        if(idProceso) {

            getProcesoOrganizacion(idProceso).then((res) => {

                if(res.data.code === 200) {

                    //console.log("getProcesoOrganizacion data-->",res.data);

                    setOrganizacion(res.data);

                } else {

                    //console.log("Entro en el else getProcesoOrganizacion");

                    setOrganizacion(null);
                }

            }).catch((error) => {
                console.log(error);
                setRatificacion(null);
            });

            getPaginaAcreditaciones(idProceso).then((res) => {

                //console.log("getPaginaAcreditaciones data-->",res.data);

                setAcreditacion(res.data.code === 200 ? res.data.listNotificaciones : null);

            }).catch((error) => {

                //console.log("Entro en getPaginaAcreditaciones", error);

                setAcreditacion(null);
            });
        }

    }, [idProceso, refresh]);

    return (
        <div>
            <Row>
                <h1>Notificaciones del sistema</h1>
            </Row>
            <Tabs defaultActiveKey="1" className="tabsNotificaciones tabsBottomLine">

                <Tabs.TabPane tab="Ratificación" key="1">
                    <Ratifica ratificacion={ratificacion} 
                              setLoader={setLoader}
                              refresh={refresh} 
                              setRefresh={setRefresh}
                              rolModulo={rolModulo}
                    />
                </Tabs.TabPane>

                <Tabs.TabPane tab="Organizaciones" key="2">
                    <Organizaciones organizacion={organizacion} 
                                    setLoader={setLoader}
                                    refresh={refresh} 
                                    setRefresh={setRefresh}
                                    rolModulo={rolModulo} 
                                    idProceso={idProceso}
                    />
                </Tabs.TabPane>

                <Tabs.TabPane tab="Acreditaciones" key="3">
                    <Acreditaciones acreditacion={acreditacion} 
                                    setLoader={setLoader}
                                    refresh={refresh} 
                                    setRefresh={setRefresh}
                                    rolModulo={rolModulo} 
                                    idProceso={idProceso}
                    />
                </Tabs.TabPane>
            </Tabs>
        </div>
    );
    
}

export default withRouter(Notifications);
